import styled from '@emotion/styled'

import { breakpoints, spacing } from 'main/ui'

const gutter = spacing.majorScale(4)

export const AchievementsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: ${-gutter}px;
  margin-right: ${-gutter}px;
  margin-top: ${spacing.majorScale(4)}px;

  @media (min-width: ${breakpoints.lg}px) {
    justify-content: flex-start;
  }
`

export const AchievementContainer = styled.div`
  margin-bottom: ${gutter}px;
  margin-right: ${gutter}px;
`
